import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DiagnosticadorVisorRoutingModule } from './diagnosticador-visor-routing.module';
import { DiagnosticadorVisorComponent } from './components/diagnosticador-visor/diagnosticador-visor.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [DiagnosticadorVisorComponent],
  imports: [CommonModule, DiagnosticadorVisorRoutingModule, FormsModule, ReactiveFormsModule],
})
export class DiagnosticadorVisorModule {}
